module.exports = new __parcel__URL__("something-went-wrong.afc195d1.svg").toString();